<template>
  <div>
    <login-widget-modal :device="device" :editing="editing" :model="site?.loginSetting" />
    <dialog-widget-modal v-if="supportDialog" :device="device" :editing="editing" :model="site?.dialogSetting" />
    <mission-center-widget-modal :editing="editing" :model="site?.missionCenterSetting" />
  </div>
</template>

<script>
import LoginWidgetModal from '../widgets/loginSetting/index'
import MissionCenterWidgetModal from '~/site/widgets/missionCenterSetting/index.vue'
import DialogWidgetModal from "~/site/widgets/dialogWidget/index.vue";
import {PageEnum} from "~/enums/pageEnum";

export default {
  name: "SiteModals",
  components: {
    LoginWidgetModal,
    MissionCenterWidgetModal,
    DialogWidgetModal
  },
  props: {
    site: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false
    },
    device: {
      type: String,
      default: 'desktop'
    }
  },
  computed: {
    supportDialog() {
      return !this.$route.fullPath.includes(PageEnum.SHOP_CART)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
